// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { deactivate, list, $delete, update, create, get } from "./operations.js";
export {
  type ConnectedRegistriesDeactivateOptionalParams,
  type ConnectedRegistriesListOptionalParams,
  type ConnectedRegistriesDeleteOptionalParams,
  type ConnectedRegistriesUpdateOptionalParams,
  type ConnectedRegistriesCreateOptionalParams,
  type ConnectedRegistriesGetOptionalParams,
} from "./options.js";
